import Vue from 'vue'
import '@/i18n/index'

import { validateCPF, validateCNPJ } from './validate'
import { clearCurrency } from './helpers'

const { i18n } = Vue
export const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const regexMultiSpace = /^\s?\S+(?: \S+)*\s?$/
const regexCode = /^[a-zA-Z0-9 _.\-\/]*$/
const regexStreetNumber = /^[a-zA-Z0-9]{1,10}$/
export const regexName = /^([a-zA-ZÀ-Ÿ0-9]{1,15}\s)([a-zA-ZÀ-Ÿ0-9 ]{1,80})$/
const regexPassword = /^[a-zA-Z0-9!@#$%^&*]{5,20}$/

const invalidBirthDate = i18n.translate('forms.invalidBirthDate')
const invalidDateDay = i18n.translate('forms.invalidDateDay')
const invalidDateMonth = i18n.translate('forms.invalidDateMonth')
const invalidDateYear = i18n.translate('forms.invalidDateYear')

const clearValue = (value) => {
  return value.replace(/[^\d]+/g, '')
}

export const required = (value) => (!!value && regexMultiSpace.test(value)) || i18n.translate('rules.required')

export const password = (value) => (!!value && regexPassword.test(value)) || i18n.translate('rules.password')

export const dateTime = (value) => (!!value && value.length >= 11 && regexMultiSpace.test(value)) || i18n.translate('appointment.formCreate.errors.dateTime')

export const dateTimePeriod = (value) => (!!value && value.length >= 11 && regexMultiSpace.test(value)) || i18n.translate('appointment.formCreate.errors.dateTimePeriod')

export const name = (value) => (!!value && regexName.test(value.trim())) || i18n.translate('appointment.formCreate.errors.name')

export const email = (value) => regexEmail.test(value) || i18n.translate('rules.email')

export const streetNumber = (value) => (!!value && regexStreetNumber.test(value)) || i18n.translate('rules.streetNumber')

export const postalCode = (value) => (!!value && value.length <= 9) || i18n.translate('rules.postalCode')

export const minLength = (value) => (!!value && value.length > 10) || 'O campo deve conter mais que 10 caracteres'

export const phone = (value) => {
  if (value) {
    const minPhoneLength = localStorage.getItem('user_country') == 'AU' ? 6 : 10
    return (
      (!!value && clearValue(value).length >= minPhoneLength) || i18n.translate('rules.phone')
    )
  }

  return false || i18n.translate('rules.phoneRequired')
}

export const code = (value) => regexCode.test(value) || i18n.translate('rules.code')

export const documentCheck = (value) => {
  const userCountry = localStorage.getItem('user_country')

  // retirar quando tivermos algum país
  // que possua validação e aplicar aqui
  if (userCountry !== 'BR') return true

  if (!value) return false || i18n.translate('rules.required')

  const document = clearValue(value)

  if (document.length <= 11) {
    return validateCPF(document) || i18n.translate('rules.cpfInvalid')
  } else {
    return validateCNPJ(document) || i18n.translate('rules.cnpjInvalid')
  }
}

export const percent = (value) => (value < 101) || i18n.translate('rules.cantBeGreaterThan100')

export const amount = (value) => (!!value && value >= 0) || i18n.translate('rules.cantBeZero')

export const cantBeNegative = (value) => {
  let parsedValue = null
  if (value && value?.includes(',')) parsedValue = clearCurrency(value)
  else parsedValue = value
  return (!!parsedValue && parsedValue >= 0) || i18n.translate('rules.cantBeNegative')
}

export const optionalNotNegative = (value) => (value === null || value === undefined || value === '' || Number(value) >= 0) || i18n.translate('rules.cantBeNegative')

export const maxLength = (length) => (value) => (value || '').length <= length || i18n.translate('rules.length', { length })

export const maxCapacity = (value) => (value || '').length <= 9 || i18n.translate('rules.maxCapacity', { value: '999 999 999' })

export const expireCard = (value) => {
  const expiryMonth = value.split('/')[0]
  const expiredYear = value.split('/')[1]
  const currentYear = new Date().getFullYear()

  if (expiryMonth < 1 || expiryMonth > 12)
    return i18n.translate('forms.expiredMonth')

  if (expiredYear < currentYear) return i18n.translate('forms.expiredYear')
}

export const expiredMonthValidation = (value) => {
  if (value.length >= 3 && value.length <= 7) {
    const expiryMonth = value.split('/')[0]
    return expiryMonth > 12 ? i18n.translate('forms.expiredMonth') : true
  }

  return true
}

export const expiredYearValidation = (value) => {
  const currentYear = new Date().getFullYear()
  const expiredYear = value.split('/')[1]
  if (value.length >= 7) {
    return expiredYear < currentYear
      ? i18n.translate('forms.expiredYear')
      : true
  }

  return true
}

// TODO: Validate February...
export const birthDateCheck = (birthDate) => {
  if (!birthDate) return invalidBirthDate

  let now = new Date();
  let currentYear = now.getFullYear();

  let parts = birthDate.split('/')

  let day = parseInt(parts[0])
  let month = parseInt(parts[1])
  let year = parseInt(parts[2])

  if (!day || (day < 1 || day > 31)) return invalidDateDay
  if (!month || (month < 1 || month > 12)) return invalidDateMonth
  if (!year || (currentYear - year < 0 || currentYear - year > 500)) return invalidDateYear

  return true
}

export const birthDateCheckNotRequired = (birthDate) => {
  if (!birthDate) return true

  let now = new Date();
  let currentYear = now.getFullYear();

  let parts = birthDate.split('/')

  let day = parseInt(parts[0])
  let month = parseInt(parts[1])
  let year = parseInt(parts[2])

  if (!day || (day < 1 || day > 31)) return invalidDateDay
  if (!month || (month < 1 || month > 12)) return invalidDateMonth
  if (!year || (currentYear - year < 0 || currentYear - year > 500)) return invalidDateYear

  return true
}

// pass empty values ------------------------------------
export const nameCheckPassEmpty = (name) => {
  if (!name) return true
  return regexName.test(name.trim()) || i18n.translate('appointment.formCreate.errors.name')
}

export const match = (value, match) => {
  return (!!value && value === match) || i18n.translate('rules.passwordNeedsToBeTheSame')
}

export const emailCheckPassEmpty = (email) => {
  if (!email) return true
  return regexEmail.test(email) || i18n.translate('rules.email')
}

export const phoneCheckPassEmpty = (phone) => {
  if (!phone) return true
  const minPhoneLength = localStorage.getItem('user_country') == 'AU' ? 6 : 10
  return clearValue(phone).length >= minPhoneLength || i18n.translate('rules.phone')
}

// check a better way to do this
export const birthDateCheckPassEmpty = (birthDate) => {
  if (!birthDate) return true
  return birthDateCheck(birthDate)
}

export const documentCheckPassEmpty = (document) => {
  if (!document) return true
  return documentCheck(document)
}
// /pass empty values -----------------------------------

export const checkPastedPhoneNumber = (phone) => {
  const onlyNumbers = phone.replace(/\D/g, '')
  const checkFirstChars = onlyNumbers.slice(0,2)

  if (checkFirstChars === '55') return onlyNumbers.slice(2)
  return onlyNumbers
}

export const handleErrorMessage = (data) => {
  const errors = data?.errors

  if (!errors) return data?.message ?? 'Error'

  if (errors.length) {
    for (let i = 0; i < errors.length; i++) {
      const error = errors[i]
      const field = error.field
      const message = error.message

      if (field) return `${i18n.translate(field)}: ${message}`
      return message
    }
  }
}
